import Amplify from 'aws-amplify';
import axios from 'axios';

export default {

    async config(): Promise<any> {
        const client = location.host.substr(0, location.host.indexOf('.')) || 'dev'; 
        const res = await axios.get(`https://api.goepik.io/client/${client.toUpperCase()}`);
        const json = res.data;
        return json.data;
    },

    async init(): Promise<any> {

        const client = await this.config();

        const config = {
            Auth: {
                identityPoolId: client.auth.identityPoolID,
                region: client.auth.region,
                userPoolId: client.auth.userPoolID,
                userPoolWebClientId: client.auth.appClientID,
                mandatorySignIn: true,
            },
            API: {
                endpoints: client.pillars.map((e: any) => {
                    return {
                        "name": e.id,
                        "endpoint": `${e.endpoint}/`
                    }
                }),
                graphql_endpoint: 'https://dev-api.goepik.io/graphql/'
            },
            Storage: {
                bucket: client.storage ? client.storage.bucket : '', //REQUIRED -  Amazon S3 bucket
                region: client.storage ? client.storage.region : '',
            }
        }
        
        if(process.env.REACT_APP_STAGE === 'dev'){
            let endpoints = config.API.endpoints;
            endpoints.push({
                name: "DEV",
                endpoint: "http://localhost:4000/"});
            config.API.endpoints = endpoints;
        }

        Amplify.configure(config);
        client.pillars = client.pillars.map((e: any) => e.id)
        delete client.auth;
        return client;
    }
};